/**
 * Facebook API (Facebook, Instagram) related constants
 */
export const FACEBOOK_INSTAGRAM_BUSINESS_SCOPES = [
  "email",
  "public_profile",
  "publish_to_groups",
  "pages_show_list",
  "pages_read_engagement",
  "pages_manage_posts",
  "pages_manage_engagement",
  "read_insights",
  "instagram_basic",
  "instagram_content_publish",
  "pages_read_user_content",
  "instagram_manage_insights",
];

/**
 * Instagram App related constants
 */
export const INSTAGRAM_SCOPES = [
  "user_profile",
];

/**
 * Pinterest App related constants
 */
export const PINTEREST_SCOPES = [
  "user_accounts:read",
  "boards:read",
  "boards:read_secret",
  "boards:write",
  "boards:write_secret",
  "pins:read",
  "pins:read_secret",
  "pins:write",
  "pins:write_secret",
];

/**
 * TikTok App related constants
 */
export const TIKTOK_SCOPES = [
  "user.info.basic",
  // "share.sound.create",
  "video.list",
  "video.upload",
];

/**
 * LinkedIn App related constants
 */
export const LINKEDIN_SCOPES = [
  "r_basicprofile",
  "rw_organization_admin",
  "r_organization_social",
  "w_organization_social",
  "w_member_social",
];

/**
 * Shopify app related constants
 */
export const SHOPIFY_SCOPES = ["read_products", "read_product_listings"];

/**
 * GMB related constants
 */
export const GMB_SCOPES = [
  "https://www.googleapis.com/auth/business.manage",
  "profile",
  "email",
];

/**
 * YouTube related constants
 */
export const YOUTUBE_SCOPES = [
  "https://www.googleapis.com/auth/youtube.force-ssl",
];
